import React from "react";

export const Title = (props: any) => {
  return (
    <div className="ui-population-insight__title">
      <div className="ui-population-insight__title__suffix">{props.suffix}</div>
      <div className="ui-population-insight__title__text">{props.text}</div>
    </div>
  );
};
